<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div>
            <vue-headful :title="`Edit: ${account.ClientName} :: MeritEHS`" v-if="SmartBizClientId" />
            <vue-headful :title="`New Account :: MeritEHS`" v-else />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/dev/accounts`">
                            <i class="fa fa-key"></i> MeritEHS Accounts
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/dev/accounts/view/${account.SmartBizClientId}`">
                            {{ account.ClientName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-edit"></i> Billing
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <div class="card mb-4">
                        <div class="card-header">Credit Card Details</div>
                        <div class="card-body">
                            <label class="text-muted">Card Type:</label> <span v-if="account && account.card_brand">{{ account.card_brand }}</span><br>
                            <label class="text-muted">Current Card:</label> <span v-if="account && account.card_last_four">XXXX-XXXX-XXXX-{{ account.card_last_four }}</span><br>
                            <label class="text-muted">Last Billing Date:</label> <span v-if="account.last_billed_at">{{ account.last_billed_at | moment("MM/DD/YYYY") }}</span><br>
                            <label class="text-muted">Next Billing Date:</label> <span v-if="account.next_bill_date">{{ account.next_bill_date }}</span>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">Update Credit Card</div>
                        <div class="card-body">
                            <div id="card-element"></div>
                            <div id="card-errors" class="text-danger"></div>
                            <hr/>

                            <div class="row form-group mt-3">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.billing_email}">
                                    Billing Email: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <b-form-input v-model="account.billing_email" placeholder="Enter Billing Email Address" :class="{'is-invalid': errors.billing_email}"></b-form-input>

                                    <div v-if="errors.billing_email" class="text-danger mt-2">
                                        <span v-for="error in errors.billing_email">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-success" v-on:click="updateCard()" :disabled="saving">
                                <template v-if="saving">Updating</template>
                                <template v-else>Update Credit Card</template>
                            </button>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">User Licenses</div>
                        <div class="card-body">
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.billing_plan_id}">Billing Plan:</label>
                                <div class="col-sm-8">
                                    <b-form-select v-model="account.billing_plan_id" :options="planOptions" :class="{'is-invalid': errors.billing_plan_id }" />

                                    <span v-if="errors.billing_plan_id" class="text-danger">
                                        <span v-for="error in errors.billing_plan_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <template v-if="planHasCounts">
                                <div class="form-group row">
                                    <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.prepaid_nbr_users}">
                                        Standard User Licenses:<br/>
                                        <span class="text-muted" v-if="stripe_plan">${{ stripe_plan.amount / 100 }} / user</span>
                                    </label>
                                    <div class="col-sm-8">

                                        <b-form-input v-model="account.prepaid_nbr_users" type="number" :class="{'is-invalid': errors.prepaid_nbr_users}" placeholder="Enter Number of Standard Users"></b-form-input>

                                        <span v-if="errors.prepaid_nbr_users" class="text-danger">
                                            <span v-for="error in errors.prepaid_nbr_users">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row" v-if="false">
                                    <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.prepaid_nbr_action_users}">
                                        Corrective Action Licenses:<br/>
                                        <span class="text-muted" v-if="stripe_action_plan">${{ stripe_action_plan.amount / 100 }} / user</span>
                                    </label>
                                    <div class="col-sm-8">

                                        <b-form-input v-model="account.prepaid_nbr_action_users" type="number" :class="{'is-invalid': errors.prepaid_nbr_action_users}" placeholder="Enter Number of Corrective Action Users"></b-form-input>

                                        <span v-if="errors.prepaid_nbr_action_users" class="text-danger">
                                            <span v-for="error in errors.prepaid_nbr_action_users">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="row form-group" v-if="!account.last_billed_at">
                                    <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.bill_now}">Bill the Customer Now:</label>
                                    <div class="col-sm-8">
                                        <b-form-checkbox v-model="bill_now" :value="true" :unchecked-value="false" plain />
                                        <span v-if="errors.bill_now" class="text-danger">
                                            <span v-for="error in errors.bill_now">{{ error }}</span>
                                        </span>

                                    </div>
                                </div>

                                <div class="alert alert-warning mt-3">
                                    <p v-if="!account.last_billed_at || (calculatingProratedCost || proratedCost > 0.50)">
                                        If selected "Bill Now" or changing the license counts, the Account will immediately be billed.<br/>
                                        Estimated Prorated Bill: <i class="fa fa-spin fa-spinner" v-if="calculatingProratedCost"></i><strong v-else>${{ proratedCost }}</strong>.
                                    </p>
                                    <p>The Customer's bill will be on the 1st of every month for <strong>${{ totalbill }}</strong></p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="card">
                        <div class="card-header">Billing Plans</div>
                        <div class="card-body">
                            <div v-for="plan in plans">
                                <h5>{{ plan.plan_name }}</h5>
                                <p>{{ plan.plan_description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" v-on:click="saveAccount()" :disabled="saving">
                <template v-if="account.SmartBizClientId">Update</template>
                <template v-else>Create</template>
                Account Billing
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                calculatingProratedCost: false,
                stripe: null,
                elements: null,
                card: null,
                stripeToken: null,
                bill_now: false,
                stripe_plan: null,
                stripe_action_plan: null,
                currentstandardCount: null,
                currentActionCount: null,
                proratedCost: null,

                plans: [],
                SmartBizClientId: this.$route.params.id,
                query: this.$route.query,
                account: {},
                user: {},
                errors: {},
                userTimezone: this.$store.state.user.timezone,
                dateTimeOptions: {
                    format: 'MM/DD/YYYY hh:mm A',
                    useCurrent: false,
                    timeZone: this.$store.state.user.timezone,
                },
                prepaidOptions: {
                    format: 'MM/DD/YYYY',
                    useCurrent: false,
                },
            }
        },

        watch: {
            'account.prepaid_nbr_users'(newVal, oldVal){
                //Check it
                if(newVal > oldVal)
                {
                    this.getProratedCost();
                }
            },

            'account.prepaid_nbr_action_users'(newVal, oldVal){
                //Check it
                if(newVal > oldVal)
                {
                    this.getProratedCost();
                }
            },

            bill_now(newVal, oldVal){
                //Check it
                if(newVal == true)
                {
                    this.getProratedCost();
                }
            },
        },

        computed: {
            planOptions(){
                //Setup options
                var options = [];

                //Loop through and build lists
                for(var i = 0; i < this.plans.length; i++)
                {
                    //Push onto options
                    options.push({value: this.plans[i].id, text: this.plans[i].plan_name});
                }

                //Send it
                return options;
            },

            planHasCounts(){
                //Send
                return this.account.billing_plan_id != 1;
            },

            proratedCost_OLD(){
                //Setup
                var now = moment();
                var end = now.clone().endOf('month');

                //Get the difference in days
                var daysActive = end.diff(now, 'days');
                var totalDays = now.daysInMonth();

                //Set the charge
                var prorationRate = daysActive / totalDays;
                var amount = 0;

                //Check Users
                if(parseInt(this.account.prepaid_nbr_users) > 0)
                {
                    amount += (this.stripe_plan.amount / 100) * (parseInt(this.account.prepaid_nbr_users) - parseInt(this.currentstandardCount)) * prorationRate;
                }

                //Action Users
                if(parseInt(this.account.prepaid_nbr_action_users) > 0)
                {
                    //amount += (this.stripe_action_plan.amount / 100) * (parseInt(this.account.prepaid_nbr_action_users) - parseInt(this.currentActionCount)) * prorationRate;
                }

                //SEnd it
                return amount.toFixed(2);
            },

            totalbill(){
                //Setup
                var amount = 0;

                //Check Users
                if(parseInt(this.account.prepaid_nbr_users) > 0)
                {
                    amount += (this.stripe_plan.amount / 100) * parseInt(this.account.prepaid_nbr_users);
                }

                //Action Users
                if(parseInt(this.account.prepaid_nbr_action_users) > 0)
                {
                    //amount += (this.stripe_action_plan.amount / 100) * parseInt(this.account.prepaid_nbr_action_users);
                }

                //SEnd it
                return amount.toFixed(2);
            },
        },


        methods: {

            getAccount() {
                //Get the data
                this.$http
                    .get('dev/accounts/billing/' + this.SmartBizClientId, this.query)
                    .then(response => {
                        //Done loading - The Card Element has to be rendered for stripe to work
                        this.loading = false;

                        //Set all the data
                        this.account = response.data.account;
                        this.plans = response.data.plans;
                        this.currentstandardCount = this.account.prepaid_nbr_users;
                        this.currentActionCount = this.account.prepaid_nbr_action_users;

                        //Set the Plans
                        this.stripe_plan = response.data.stripePlan;
                        this.stripe_action_plan = response.data.stripeActionPlan;

                        //Setup Stripe Elements
                        this.stripe = Stripe(response.data.publicKey);
                        this.elements = this.stripe.elements();

                        //Create the card
                        this.card = this.elements.create('card', {style: {base: {fontSize: '16px', color: '#32325d'}}});

                        //Mount it
                        this.card.mount('#card-element');

                        //Add the event listener
                        this.card.addEventListener('change', ({error}) => {
                            //Display the errors
                            const displayError = document.getElementById('card-errors');

                            //Check for an error
                            if (error)
                            {
                                displayError.textContent = error.message;
                            }
                            else
                            {
                                displayError.textContent = '';
                            }
                        });
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            saveAccount(){
                //Errors
                this.errors = {};

                //Indicator
                this.saving = true;

                //Set other values
                this.account.bill_now = this.bill_now;
                this.account.prepaid_nbr_users = parseInt(this.account.prepaid_nbr_users);
                this.account.prepaid_nbr_action_users = parseInt(this.account.prepaid_nbr_action_users);

                //Send it
                this.$http.post('/dev/accounts/billing/' + this.SmartBizClientId, this.account)
                    .then(response => {
                        //Alert
                        this.$toastr.success('Account Billing Updated');

                        //Send to home
                        this.$router.push('/dev/accounts/view/'+this.account.SmartBizClientId);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Update Billing');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },

            saveBilling(){
                //Reset the Errors
                this.errors = {};

                //Build it
                var payload = {
                    stripeToken: this.stripeToken,
                    billing_email: this.account.billing_email,
                    SmartBizClientId: this.account.SmartBizClientId
                };

                //Send it
                this.$http.post('/billing', payload)
                    .then(response => {
                        //UPdate the Account
                        this.account = response.data;

                        //Reset the card?
                        this.card.clear();

                        //Alert
                        this.$toastr.success('Credit Card Updated');

                        //Send to home
                        //this.$router.push('/dev/accounts/view/'+this.account.SmartBizClientId);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Update Billing');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });

            },

            updateCard(){
                //Saving
                this.saving = true;

                //IF there is no Card value, just save the

                //Create the TOKEN
                this.stripe.createToken(this.card).then(result => {
                    //Check for an error
                    if(result.error)
                    {
                        // Inform the customer that there was an error.
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;

                        //Reset
                        this.saving = false;
                    }
                    else
                    {
                        //Set the token
                        this.stripeToken = result.token;

                        // Send the token to your server.
                        this.saveBilling();
                    }
                });
            },

            includeStripe( URL, callback ){
                let documentTag = document, tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];

                //Set SRC
                object.src = '//' + URL;

                //Set Callback
                if (callback)
                {
                    object.addEventListener('load', function (e) { callback(null, e); }, false);
                }

                //Setup
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },

            getProratedCost(){
                //setup
                this.calculatingProratedCost = true;

                //Build it
                var payload = {
                    prepaid_nbr_users: this.account.prepaid_nbr_users,
                    prepaid_nbr_action_users: this.account.prepaid_nbr_action_users,
                    bill_now: this.bill_now,
                };

                //Send it
                this.$http.get('/billing/calc-prorated-cost/' + this.account.SmartBizClientId, payload)
                    .then(response => {
                        //Set the value
                        if(response.data && response.data > 0)
                        {
                            this.proratedCost = response.data.toFixed(2);
                        }
                        else
                        {
                            this.proratedCost = null;
                        }

                        //Reset
                        this.calculatingProratedCost = false;
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Calculate Prorated Cost');
                        }

                        //Reset
                        this.calculatingProratedCost = false;
                    })
                    .then(() => {

                    });
            },
        },

        mounted() {
            //Get the Accounts
            this.$nextTick(function () {
                //Setup Stripe
                this.includeStripe('js.stripe.com/v3/', function(){
                    //Load the respources
                    this.getAccount();
                }.bind(this));
            });
        }
    }
</script>
